export const NIKE_URL =
  process.env.NEXT_PUBLIC_NIKE_URL ||
  "https://www.tradingvalley.tw/api/stock-mining";
